export default __webpack_public_path__ + "static/media/trr-food-pastry-7.243824c5.png";